// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___2VWJZ","skeleton-loading":"styles__skeleton-loading___382z-","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___1XvIr","skeletonText":"styles__skeletonText___2ysHL","hoursBalanceText":"styles__hoursBalanceText___1_Ph1","skeletonSelect":"styles__skeletonSelect___1-3ph","skeletonDetails":"styles__skeletonDetails___3vDBn","mainSectionSkeleton":"styles__mainSectionSkeleton___3Lj6C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/ManagerOnlineInterfaceSkeleton/styles.css
// module id = 2526
// module chunks = 0